import { render, staticRenderFns } from "./MasterDepartmentEdit.vue?vue&type=template&id=4d792cbb&scoped=true&lang=pug&"
import script from "./scripts/MasterDepartmentEdit.js?vue&type=script&lang=js&"
export * from "./scripts/MasterDepartmentEdit.js?vue&type=script&lang=js&"
import style0 from "./MasterDepartmentEdit.vue?vue&type=style&index=0&id=4d792cbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d792cbb",
  null
  
)

export default component.exports